<div class="container" fxLayout="column">
  <div *ngIf="!hideActionButtons"
    class="full-width" fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="end center">
    <button [disabled]="selectedTemplate == null" mat-icon-button (click)="clearCurrentSelectedTemplate()">
      <mat-icon class="material-icons-outlined" >keyboard_return</mat-icon>
    </button>
    <button [disabled]="selectedTemplate == null" mat-flat-button class="button-primary-dark"
            (click)="saveAndExportHtml()">
      <div class="button-text">Save and Activate</div>
    </button>
  </div>

  <div fxLayout="row" class="full-width">
    <div class="unlayer-editor-container full-width">
      <div id="{{pageId}}" class="unlayer-editor" [hidden]="selectedTemplate == null"></div>
    </div>
  </div>
</div>
